import { UserState } from "./types";

export default {
  SET_DATA_BY_KEY: (state: UserState, { key, value }: { key: keyof UserState, value: UserState[keyof UserState] | null }) => {
    if (value !== null) {
      // @ts-ignore
      state[key] = value;
    }
  },
};